// extracted by mini-css-extract-plugin
export default {"formTitle":"security-management_formTitle__+sUlD"};